import React from 'react';
import { Calendar, MapPin, Users, Award } from 'lucide-react';

const ConferenceGallery = () => {
  const conferencePhotos = [
    {
      url: "https://customer-assets.emergentagent.com/job_social-impact-47/artifacts/0mtfdkve__DSC4160.JPG",
      title: "Conference Gathering"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_social-impact-47/artifacts/qsc9mo5e__DSC4176.JPG",
      title: "Participants & Speakers"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_social-impact-47/artifacts/thzg1p7x__DSC4331.JPG",
      title: "Conference Session"
    },
    {
      url: "https://customer-assets.emergentagent.com/job_social-impact-47/artifacts/vsq8qsko__DSC4338.JPG",
      title: "Event Highlights"
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-orange-50 via-yellow-50 to-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-orange-100 rounded-full mb-4">
            <Award className="w-5 h-5 text-orange-600" />
            <span className="text-sm font-semibold text-orange-700">Recent Event</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Buddha and His Dhamma Conference
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto mb-8">
            State-level two days conference organized by MMT and Buddhist Fraternity Council
          </p>
          
          {/* Event Details */}
          <div className="flex flex-wrap justify-center gap-6 text-left">
            <div className="flex items-center gap-3 bg-white px-6 py-3 rounded-lg shadow-md">
              <Calendar className="w-6 h-6 text-blue-600" />
              <div>
                <p className="text-sm text-gray-600">Date</p>
                <p className="font-bold text-gray-900">July 27, 2025</p>
              </div>
            </div>
            <div className="flex items-center gap-3 bg-white px-6 py-3 rounded-lg shadow-md">
              <MapPin className="w-6 h-6 text-orange-600" />
              <div>
                <p className="text-sm text-gray-600">Location</p>
                <p className="font-bold text-gray-900">Trichy, Tamil Nadu</p>
              </div>
            </div>
            <div className="flex items-center gap-3 bg-white px-6 py-3 rounded-lg shadow-md">
              <Users className="w-6 h-6 text-green-600" />
              <div>
                <p className="text-sm text-gray-600">Organized By</p>
                <p className="font-bold text-gray-900">MMT & BFC</p>
              </div>
            </div>
          </div>
        </div>

        {/* Conference Description */}
        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 mb-12">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">About the Conference</h3>
          <p className="text-lg text-gray-700 leading-relaxed mb-4">
            MMT, in collaboration with <strong>Buddhist Fraternity Council (BFC)</strong>, successfully conducted a state-level two-day conference on <strong>"The Buddha and His Dhamma"</strong>. This landmark event brought together scholars, practitioners, and community members to discuss Dr. Ambedkar's vision of Buddhism as a path to social transformation.
          </p>
          <p className="text-lg text-gray-700 leading-relaxed">
            The conference featured enlightening discussions on Buddhist philosophy, Dhamma teachings, and practical applications of Buddhist principles in modern society. Participants engaged in meaningful dialogue about continuing Dr. Ambedkar's mission of social equality through Buddhist revival.
          </p>
        </div>

        {/* Photo Gallery */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {conferencePhotos.map((photo, index) => (
            <div 
              key={index}
              className="group relative rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
            >
              <img 
                src={photo.url} 
                alt={photo.title}
                className="w-full h-80 object-cover group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end">
                <div className="p-6">
                  <p className="text-white text-xl font-semibold">{photo.title}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Conference Impact */}
        <div className="mt-12 bg-gradient-to-r from-blue-600 to-blue-700 rounded-2xl shadow-2xl p-8 md:p-12 text-white text-center">
          <h3 className="text-3xl font-bold mb-4">Conference Impact</h3>
          <p className="text-xl text-blue-100 max-w-3xl mx-auto mb-8">
            This conference reinforced the importance of Dr. Ambedkar's writings and strengthened the Buddhist community's commitment to social transformation through Dhamma.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
            <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl border border-white/20">
              <p className="text-4xl font-bold mb-2">2</p>
              <p className="text-blue-100">Days of Learning</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl border border-white/20">
              <p className="text-4xl font-bold mb-2">State</p>
              <p className="text-blue-100">Level Conference</p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl border border-white/20">
              <p className="text-4xl font-bold mb-2">100+</p>
              <p className="text-blue-100">Participants</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ConferenceGallery;